import React from 'react';
import { useIntl } from 'react-intl';

import { useLayout } from '~hooks/useLayout';
import { useSeo } from '~hooks/useSeo';

import Hero from '~components/hero';

// import ChangePassword from './change-password';
import Contact from './contact';

import './style.scss';

const Settings = () => {
  const intl = useIntl();

  useLayout({ type: 'account', displayCities: false });
  useSeo(intl.formatMessage({ id: 'containers.settings.title', defaultMessage: 'Settings' }));

  return (
    <div className="c-account__main l-container">
      <Hero.Wrapper>
        <Hero.Title>{intl.formatMessage({ id: 'containers.settings.headline', defaultMessage: 'Settings' })}</Hero.Title>
      </Hero.Wrapper>
      <div>
        <Contact />
        {/* <ChangePassword /> */}
      </div>
    </div>
  );
};

export default Settings;
